import { useState } from 'react';

export const useSnackbar = () => {
  const [isShowedUp, setIsShowedUp] = useState<boolean>(false);
  const showSnackbar = () => {
    if (isShowedUp) return;
    setIsShowedUp(true);
    setTimeout(() => setIsShowedUp(false), 3000);
  };

  const closeSnackbar = () => {
    setIsShowedUp(false);
  };

  return { isShowedUp, showSnackbar, closeSnackbar };
};
